module.exports = __webpack_public_path__ + "img/hxgl.a30d837c.png";